import React, { useState } from "react";

const NwcTable = ({ values, computedValues }) => {
  const KEYS = ["working_capital"];
  const KEYS_LABEL = {
    working_capital: "Besoin en fonds de roulement",
  };

  const years = Array.from(Array(11).keys()).map((i) => (values?.year_4 || 0) - 4 + i);

  return (
    <div className="w-full overflow-x-auto">
      <h3 className="font-semibold text-lg mb-2">BFR</h3>
      <table className="min-w-full bg-white border rounded-lg border-gray-300 table-fixed">
        <thead>
          <tr className="">
            <th colSpan="1" className="border text-gray-700 font-normal text-sm"></th>
            <th colSpan="4" className="border p-2  text-left text-gray-700 font-normal text-sm">
              {"Bilan passé"}
            </th>
            <th colSpan="7" className="border p-2 text-left text-gray-700 font-normal text-sm">
              {"Bilan prévisionnel"}
            </th>
          </tr>
          <tr className="text-sm">
            <th className="border p-2">{"Année"}</th>
            {years.map((year) => (
              <th key={year} className="border p-2">
                {year}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {KEYS.map((key) => (
            <tr key={key}>
              <td className="border p-2 text-xs w-56">{KEYS_LABEL[key]}</td>
              {years.map((year, index) => (
                <td key={year} className={`border text-xs px-2`}>
                  {values[`${key}_${index}`]}
                </td>
              ))}
            </tr>
          ))}
          {computedValues && (
            <tr>
              <td className="border p-2 text-xs w-56">{"Variation du BFR"}</td>
              {years.map((year, index) => (
                <td key={year} className="bg-gray-100 text-xs px-2 text-right border">
                  {computedValues.net_working_capital[index]}
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NwcTable;
